import React from "react";

function PatientPortal() {
  return (
    <div style={{ padding: "2rem" }}>
      <h2>Patient Portal</h2>
      <p>
        Access your medical records, schedule appointments, and stay connected
        with your therapist through our secure portal.
      </p>
    </div>
  );
}

export default PatientPortal;
